/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bell-line': {
    width: 17,
    height: 20,
    viewBox: '0 0 17 20',
    data: '<path pid="0" d="M16.443 15.668a4.964 4.964 0 01-2-4.002V8.333A6.12 6.12 0 0010 2.453v-.786C10 .747 9.252 0 8.333 0c-.92 0-1.667.748-1.667 1.667v.786a6.121 6.121 0 00-4.444 5.88v3.333a4.964 4.964 0 01-2 4.002.555.555 0 00.333.999H5.61A2.782 2.782 0 008.331 20a2.782 2.782 0 002.723-3.333h5.055a.555.555 0 00.333-1h.001zM7.777 1.667a.556.556 0 011.111 0v.58a6.062 6.062 0 00-1.11 0v-.58zM10 17.22c0 .92-.747 1.667-1.666 1.667a1.668 1.668 0 01-1.572-2.222h3.143c.063.178.095.365.095.555zm-8.064-1.666a6.17 6.17 0 00.732-1.112 6.041 6.041 0 00.666-2.777V8.333c0-2.757 2.243-5 5-5 2.755 0 5 2.243 5 5v3.333a6.094 6.094 0 001.397 3.889H1.934h.001z" _fill="#333" fill-rule="nonzero"/>'
  }
})
